import { Autocomplete, Button } from "src/components";
import crossIcon from "../../assets/cross.svg";
import { useEffect, useState } from "react";
import { getRejectionCategory, rejectInvoice } from "src/services/invoice-api";
import { useToast } from "src/hooks/useToast";
import { useEventStatus } from "src/hooks/useEventStatus";
import { useSelector } from "react-redux";
import { RootState } from "src/context/store";

const InvoiceReject = ({
  onCloseModal,
  invoiceData,
  tab
}: {
  onCloseModal: () => void;
  invoiceData: any;
  company_code?: any[];
  division_code?: any[];
  startDate?: Date | string;
  endDate?: Date | string;
  assignee_id?: any[];
  city?: any[];
  district?: any[];
  state?: any[];
  ordering?: any[];
  status?: any[];
  tab?: string;
  fuidStatusId?: number
}) => {
  const [remarks, setRemarks] = useState<string>("");
  const [rejectionCategory, setRejectionCategory] = useState<any>([]);
  const [rejectionCategoryId, setRejectionCategoryId] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { InvoiceFilters, InvoiceApprovalFilters } = useSelector((state: RootState) => state.invoice);

  const company_code = tab == "entry" ? InvoiceFilters?.company?.[0]?.code : InvoiceApprovalFilters?.company?.[0]?.code;

  const { withEventCheck } = useEventStatus();

  const { toast } = useToast();

  const fetchRejectionCategory = async () => {
    const res = await getRejectionCategory(company_code);
    setRejectionCategory(res?.data?.data);
  };

  useEffect(() => {
    fetchRejectionCategory();
  }, []);

  const handleInvoiceReject = async () => {
    setIsLoading(true);
    const payload = {
      data: {
        stockist_invoice_attachment_id: invoiceData?.stockist_invoice_attachment_id,
        rejection_inv_category_id: rejectionCategoryId,
        remarks: remarks,
      },
      primary_key: invoiceData?.stockist_invoice_attachment_id,
      event_type: "STOCKIST_ATTACHMENT_REJECT",
    };
    try {
      if (!rejectionCategoryId) {
        toast({ description: "Please select a category of rejection", variant: "destructive" });
        return;
      }
      const res = await rejectInvoice(payload, company_code);
      const invoiceStatusUpdateResponse = await withEventCheck(
        async () => {
          // const params = {
          //   company_code: company_code?.map((item) => item.code)?.join(",") || "",
          //   division_code: division_code?.map((item) => item.company_divisioncode)?.join(",") || "",
          //   startDate: startDate,
          //   endDate: endDate,
          //   assignee_id: assignee_id?.map((item) => item.invoice_assignment_id)?.join(",") || "",
          //   city: city?.map((item) => item.city_name?.split("|")?.[0]?.trim())?.join(",") || "",
          //   district: district?.map((item) => item.district_name)?.join(",") || "",
          //   state: state?.map((item) => item.state_name)?.join(",") || "",
          //   ordering: ordering?.[0]?.key || "DESC",
          //   fuid_status_id: status?.map((item) => item.fuid_status_id)?.join(",") || (tab === "approval" ? "6,8" : "1"),
          //   screen: tab === "approval" ? "Approval" : "Entry",
          //   page_size: 10,
          //   page_number: 1,
          // };
          // const allInvoicesRes = await fetchInvoicesData(params);
          // if (tab === "approval") {
          //   dispatch(invoiceActions.setInvoiceApprovalList(allInvoicesRes?.data?.data?.invoiceData || []));
          // } else {
          //   dispatch(invoiceActions.setInvoiceData(allInvoicesRes?.data?.data?.invoiceData || []));
          // }
          // navigate("/transactions/invoice/0")
          // setIsLoading(false)
        },
        res?.data?.data?.eventStreamCreated?.streamId
      );
      console.log(invoiceStatusUpdateResponse)
      toast({ description: "Invoice rejected successfully", variant: "default" });
      onCloseModal();
    } catch (error: any) {
      console.log(error);
    } finally {
      setIsLoading(false);
      onCloseModal();
    }
  };

  return (
    <div className="flex flex-col gap-y-2 w-[500px] h-[400px] mx-auto bg-white p-4 border border-gray-300 shadow-lg rounded-lg">
      <div className="flex justify-between items-center">
        <p className="text-normal py-1 font-semibold text-[#1B1A1F]">Reject Invoice</p>
        <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
          <img src={crossIcon} alt="cross" className="w-5 h-5 font-bold invert cursor-pointer" />
        </Button>
      </div>
      <p className="text-sm mb-2 font-normal text-[#666666]">Select a category of rejection</p>
      <Autocomplete
        inputClassName="w-full"
        placeholder="E-Invoice is mandatory"
        suggestionList={rejectionCategory}
        displayKey="rejection_inv_category_desc"
        uniqueKey="rejection_inv_category_id"
        onSelectionChange={(e: any) => setRejectionCategoryId(e?.rejection_inv_category_id)}
      />
      <p className="pt-2">Remarks</p>
      <textarea
        value={remarks}
        onChange={(e) => setRemarks(e.target.value)}
        placeholder="Write your remarks here"
        className="p-2 mb-2 resize-none border bg-[#f7f7f7] max-h-[120px] h-[120px] border-gray-300 rounded-md"
      />
      <Button disabled={isLoading} isLoading={isLoading} loaderSize="small" className="text-white bg-[#8051FF]" onClick={handleInvoiceReject}>
        Proceed
      </Button>
    </div>
  );
};

export default InvoiceReject;
